var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRidgeline({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 36C6.84211 36 8.52632 44.4542 2 48H18C11.8947 44.5906 12.9474 36 10 36Z",
    fill: "#8CBFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34 11C28.8684 11 31.6053 37.0672 21 48H47C37.0789 37.4877 38.7895 11 34 11Z",
    fill: "#8CBFFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 47C13.1739 47 14.4015 35 11 35C7.59849 35 8.82609 47 1 47",
    stroke: "#2B6299",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49 47C37.2609 47 39.1023 10 34 10C28.8977 10 30.7391 47 19 47",
    stroke: "#2B6299",
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0V48H49",
    stroke: "#B3B3B3",
    strokeWidth: 0.990534,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRidgeline);
export default __webpack_public_path__ + "static/media/ridgeline.ca840217.svg";
export { ForwardRef as ReactComponent };